import axios from "axios";
import { useState } from "react";
import Cookies from "js-cookie";
import { useToast } from "@/comn/hooks";
import { _TEST1234 } from "@/comn/features/config/ApiConfig";

const publicApi = axios.create();

const caseMap: any = {
    tancis: {
        base: () => process.env.REACT_APP_API_PTLI,
        sendOtp: "/api/v1/ptli/mypage/myinfo/sendOtp",
        actvAcc: "/api/v1/ptli/mypage/myinfo/actvAcc",
    },
    tanesw: {
        base: () => process.env.REACT_APP_API_PTLE,
        sendOtp: "/api/v1/ptle/extptl/mypage/myinfochg/sendOtp",
        actvAcc: "/api/v1/ptle/extptl/mypage/myinfochg/actvAcc",
    },
    taneswLCM: {
        base: () => process.env.REACT_APP_API_PTLE,
        sendOtp: "/api/v1/ptle/extptl/mypage/myinfochg/sendOtp",
        actvAcc: "/api/v1/ptle/extptl/mypage/myinfochg/actvAcc",
    },
};

const getKey = (isLcm: boolean): string => {
    const group = _TEST1234.SYSTEM_GROUP_ORI === "tanoga" ? "tanesw" : _TEST1234.SYSTEM_GROUP_ORI;
    return group + (isLcm ? "LCM" : "");
};

const getHeaders = () => ({
    "Accept-Language": Cookies.get("lang")?.toUpperCase() || "EN",
    "_disableIndicator": true
});

export const useActivateAccount = () => {
    const { showToast } = useToast();
    const [form, setForm] = useState({ usrId: "", usrEmlAddr: "", isLcm: false });

    // DTO Engine: Dynamically maps keys without altering or affecting TANCIS
    const buildPayload = (usrId: string, usrEmlAddr: string, isLcm: boolean) => {
        const basePayload = { usrEmlAddr, isLcm }; // Exact variable name required by Java Jackson parser
        const systemGroup = _TEST1234.SYSTEM_GROUP_ORI === "tanoga" ? "tanesw" : _TEST1234.SYSTEM_GROUP_ORI;

        if (systemGroup === "tancis") {
            return { ...basePayload, usrDmnId: usrId }; // Left untouched for TANCIS stability
        }

        // Dynamically selects the proper key for TANESW vs LCM
        return isLcm
            ? { ...basePayload, coTin: usrId }
            : { ...basePayload, xtrnUsrIdntfNo: usrId };
    };

    const verifyUser = async (): Promise<boolean> => {
        const { usrId, usrEmlAddr, isLcm } = form;

        if (!usrId.trim() || !usrEmlAddr.trim()) {
            showToast({ type: "warning", content: "Please enter both ID and Email" });
            return false;
        }

        try {
            const entry = caseMap[getKey(isLcm)];
            await publicApi.post(
                entry.base() + entry.sendOtp,
                buildPayload(usrId, usrEmlAddr, isLcm), // Injects dynamic payload layout configuration
                { headers: getHeaders() }
            );
            return true;
        } catch (error: any) {
            showToast({
                type: "error",
                content: error.response?.data?.errorMessage || `The user id ${usrId} could not be found`,
            });
            return false;
        }
    };

    const verifyOtp = async (otp: string): Promise<void> => {
        const { usrId, usrEmlAddr, isLcm } = form;
        const entry = caseMap[getKey(isLcm)];

        await publicApi.post(
            entry.base() + entry.actvAcc,
            { ...buildPayload(usrId, usrEmlAddr, isLcm), otp }, // Merges clean payload with user otp input tokens
            { headers: getHeaders() }
        );
    };

    return { form, setForm, verifyUser, verifyOtp };
};